import React from "react";
import { Link } from "react-router-dom";

/*eslint-disable */

declare const window: any;

const OtrosVehiculosComponent: React.FC = () => {
  return (
    <div className="otros-vehiculos-detail-component">
      {/* H2 - Título de la sección */}
      <h2 className="title-otros-vehiculos-detail-component">
        Más oportunidades
      </h2>
      
      <div className="opciones-otros-vehiculos-detail-component">
        <div
          className={`item-opciones-otros-vehiculos-detail-component`}
          style={{
            backgroundImage: "URL(../assets/01_Home/Thumbnail_Simulador.webp)",
          }}
        >
          <div
            className={`mascara-item-opciones-otros-vehiculos-detail-component`}
          >
            {/* H3 - Título de la tarjeta */}
            <h3 className="title-mascara-item-opciones-otros-vehiculos-detail-component">
              Simula tu cuota
            </h3>
            
            {/* BOTÓN SIN MODIFICAR */}
            <Link to="/simulador-de-cuotas" className="btn-page-other-page-home-component">
              Conocer
            </Link>
          </div>
        </div>
        
        <div
          className={`item-opciones-otros-vehiculos-detail-component`}
          style={{
            backgroundImage: "URL(../assets/01_Home/Thumbnail_Concesionarios.webp)",
          }}
        >
          <div
            className={`mascara-item-opciones-otros-vehiculos-detail-component`}
          >
            {/* H3 - Título de la tarjeta */}
            <h3 className="title-mascara-item-opciones-otros-vehiculos-detail-component">
              Concesionarios
            </h3>
            
            {/* BOTÓN SIN MODIFICAR */}
            <Link to="/concesionarios" className="btn-page-other-page-home-component">
              Conocer
            </Link>
          </div>
        </div>
        
        <div
          className={`item-opciones-otros-vehiculos-detail-component`}
          style={{
            backgroundImage: "URL(../assets/01_Home/Thumbnail_Repuestos.webp)",
          }}
        >
          <div
            className={`mascara-item-opciones-otros-vehiculos-detail-component`}
          >
            {/* H3 - Título de la tarjeta */}
            <h3 className="title-mascara-item-opciones-otros-vehiculos-detail-component">
              Repuestos genuinos
            </h3>
            
            <Link to="/posventa/repuestos-genuinos" className="btn-page-other-page-home-component">
              Conocer
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtrosVehiculosComponent;